import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudSecurityGroupRule = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'security_group_rule/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllSecurityGroupRule = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_security_group_rule_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudSecurityGroupRule = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'security_group_rule/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudSecurityGroupRule = (data) => {
  return axios.request({
    url: privateCloudBaseUrl + 'security_group_rule/',
    needPrivateCloudProjectHeader: true,
    data: data,
    method: 'post'
  })
}

export const deletePrivateCloudSecurityGroupRule = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'security_group_rule/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}
